import React, {useState} from 'react';
import CheckboxTree from 'react-checkbox-tree';
import 'react-checkbox-tree/lib/react-checkbox-tree.css';

const LocationSelector = ({regionSelectorData, checked, setChecked}) => {
	const [expanded, setExpanded] = useState([])

	return (
 		regionSelectorData && (<CheckboxTree
 					nodes={regionSelectorData}
 					checked={checked}
 					expanded={expanded}
 					onCheck={(checked) => setChecked(checked)}
 					onExpand={(expanded) => setExpanded(expanded)}
 				/>)
	);
}

export default LocationSelector